module.exports = __webpack_public_path__ + "assets/img/bottom.52d1faed.png";